import { useTranslation } from "react-i18next";
import bg1 from "../assests/solutions/picture1.webp";
import bg1ar from "../assests/solutions/picture1.webp";

import bg2 from "../assests/solutions/Picture3.webp";
import bg from "../assests/solutions/new_bg.webp"
import './SOE.css';
import { FiMessageSquare, FiBarChart2, FiSettings, FiTrendingUp, FiGitMerge, FiMonitor } from "react-icons/fi";
import Approach from "./Approach";
import ZigZag from "./ZigZag";
import img1 from "../assests/picture7.png";
// import img2 from "../assests/picture8.webp";
import Partnerships from "./Partnerships";
import logo1 from "../assests/solutions/SOE-logo1.png";
import logo2 from "../assests/solutions/SOE-logo2.png";
import logo3 from "../assests/solutions/SOE-logo3.png";
import logo4 from "../assests/solutions/SOE-logo4.png";
import Header from "../Home/Header";
import Footer from "../Footer/Footer";

const SOE = () => {

    const { i18n } = useTranslation();
    const isArabic = i18n.language === "ar";
    const approachItems = [
        {
            step: 1,
            title:"Discover",
            description: "In this phase, you develop the strategies and the roadmap you will use on the implementation journey.",
        },
        {
            step: 2,
            title: "Prepare",
            description: "Initiate and plan the project. You finalize plans and assign the project team so you can start the project.",
        },
        {
            step: 3,
            title: "Explore",
            description: "This represents the most efficient and fastest scope validation and replaces blueprints of traditional projects.",
        },
        {
            step: 4,
            title: "Realize",
            description: "The ``Realize``-phase focuses on the transfer of business requirements to a working configuration of the system.",
        },
        {
            step: 5,
            title: "Deploy",
            description:"Now you set up the production environment. When you’re ready, you conduct the cutover activities and switch business operations to the new system.",
        },
        {
            step: 6,
            title: "Run",
            description: "You are ready to run! With the new system operational, you can run the environment and optimize operations.",
        },

    ];

    return (
        <>
            <div className="hd">
                <Header />
            </div>
            <section
                className="main-hero"
                style={{
                    backgroundImage: `url(${isArabic ? bg1ar : bg1})`
                }}

            >
                <div className="main-overlay2" />

                <div className="main-hero-content soe-hero-content" data-aos="fade-up" style={{ paddingLeft: isArabic ? "0px" : "70px", paddingRight: isArabic ? "70px" : "0px" }}>
                    <h1 className="main-title soe-hero-title">
                        Digitize Processes and{" "}
                        <span className="soe-hero-highlight">Customer Experience</span>
                    </h1>

                    <p className="main-subtitle soe-hero-subtitle">
                        with modern applications!
                    </p>
                </div>

            </section>

            <section
                className="cloud-info-bg"
                style={{
                    backgroundImage: `url(${bg2})`
                }}
            >
                <div className="cloud-info-overlay" />

                <div className="cloud-info-content" data-aos="fade-up" style={{ paddingLeft: isArabic ? "0px" : "70px", paddingRight: isArabic ? "70px" : "0px" }}>
                    <p>TTH's business transformation approach includes strategic involvement with our customer’s teams to achieve business benefits.  From modernizing legacy business applications for improved productivity to enabling people practices with AGILE methods, we help transform your business to scale for future!</p>
                    <p>Our Expertise: SAFE | AGILE Strategy | Assessment | Roadmap | Cloud Readiness | Migration | Upgrade | Reporting & Data Analytics | Integration with 3rd party systems | Modern UI.UX with Systems of Records | Managed Services & Support</p>
                </div>
            </section>

            <section className="soe-capabilities-section">
                <div className="container">

                    <div className="soe-capabilities-grid">

                        <div className="soe-cap-card" data-aos="fade-up">
                            <FiMessageSquare className="soe-cap-icon" />
                            <h4>Extreme Customer Experience</h4>
                            <p>Get issues resolved quickly; We drive greater customer loyalty and increase customer satisfaction by engaging users into the right channel at the right time.</p>
                        </div>

                        <div className="soe-cap-card" data-aos="fade-up" data-aos-delay="100">
                            <FiTrendingUp className="soe-cap-icon" />
                            <h4>Cloud</h4>
                            <p>Streamline your business with our modernized approach to Cloud Integration. Speed up Cloud Migration & seamless deployment with an Industry-Leading Platform.</p>
                        </div>

                        <div className="soe-cap-card" data-aos="fade-up" data-aos-delay="200">
                            <FiSettings className="soe-cap-icon" />
                            <h4>Enterprise Integration</h4>
                            <p>Ensure fast, effective implementation in technologies, processes, and team structures that connect data, applications, and devices from everywhere in your organization.</p>
                        </div>

                        <div className="soe-cap-card" data-aos="fade-up">
                            <FiGitMerge className="soe-cap-icon" />
                            <h4>Business Process Transformation</h4>
                            <p>Make progressive changes to elements of your processes to meet new business goals. Using our Agile & lean principles - incorporate new technology, save costs, and better enable your team's productivity.</p>
                        </div>

                        <div className="soe-cap-card" data-aos="fade-up" data-aos-delay="100">
                            <FiBarChart2 className="soe-cap-icon" />
                            <h4>Analytic Workflow</h4>
                            <p>Get factual suggestions and solutions for any business problems you have, with our Analytic Workflow which derives insightful values from inspecting any form of structured or unstructured data.</p>
                        </div>

                    </div>
                </div>
            </section>



            <section
                className="enterprise-agility-section"
                style={{ backgroundImage: `url(${bg})` }}
            >
                <div className="enterprise-agility-overlay"></div>

                <div className="container enterprise-agility-content">

                    {/* LEFT CONTENT */}
                    <div className="enterprise-agility-left" data-aos="fade-right">
                        <h2>Achieve Enterprise Agility</h2>
                        <p>Work with TTH to build your business transformation with our expert Mentoring, Transformational Consulting, and Training! Our customers engage with us to help them build their transformation Roadmap, the Strategy to achieve that vision – through Agile deployment and Digital technology. Online – Live – Interactive – Immersive</p>
                    </div>

                    {/* RIGHT CONTENT */}
                    <div className="enterprise-agility-right">

                        <div className="agility-card" data-aos="fade-up">
                            <FiTrendingUp className="agility-icon" />
                            <h4>Business Transformation Workshop</h4>
                            <p>Build a clear vision as to WHY transformation is required and what Technology, Process, Organization is going to be key to success for you!</p>
                        </div>

                        <div className="agility-card" data-aos="fade-up" data-aos-delay="100">
                            <FiSettings className="agility-icon" />
                            <h4>Transformation</h4>
                            <p>Create differentiation with Innovation and best practices for digital Transformation initiatives with TTH's SAFE & AGILE advisory and consulting capabilities.</p>
                        </div>

                        <div className="agility-card" data-aos="fade-up">
                            <FiMonitor className="agility-icon" />
                            <h4>Training</h4>
                            <p>Approach training differently! We enable active coaches that engage for training with your initiatives and programs. While we provide classroom based specific training, we differentiate in applying lean-agile principles while being engaged with your teams.</p>
                        </div>

                        <div className="agility-card" data-aos="fade-up" data-aos-delay="100">
                            <FiMessageSquare className="agility-icon" />
                            <h4>Mentoring</h4>
                            <p>Enabling a sounding board, a leadership skill, a mentor - to your managers, leaders and executives - to specifically achieve the transformation they are set out to build for your organization.</p>
                        </div>

                    </div>

                </div>
            </section>

            <ZigZag
                title="Cloud Migration Services (CMS)"
                description="Seamlessly migrate your infrastructure and applications to the cloud with minimal disruption. Our experts ensure a secure, scalable, and cost-optimized transition tailored to your business goals."
                image={img1}
            >
                <h5>Customer Experience</h5>
                <p>Customer Self Service can recognize the customer and personalize the experience by providing specific and relevant information, promoting improved communication while lowering the cost of routine transactions, and freeing your agents to devote more time to customers with special issues.</p>

                <h5>Cloud</h5>
                <p>Oracle’s JD Edwards cloud strategy is hybrid by design to enable your digital business by giving you choice and control. Hybrid deployment gives our customers the best of both worlds:</p>
                <ul>
                    <li>The increased agility and reduced IT complexity of a cloud-based approach</li>
                    <li>The ability to protect your existing applications investment and customizations</li>

                </ul>
            </ZigZag>
{/* 
            <ZigZag
            
                title="SAP S/4 HANA"
                description="Transforms business processes with intelligent automation and runs on a market-leading in-memory database that offers real-time processing speeds and a dramatically simplified data model.SAP S/4 HANA is the primary ERP of many of the world’s largest businesses, which automates and centralizes all business aspects. As a result, the range of S/4 HANA applications and implementations extend across every vertical and form of industry, from automobiles to IT to FMCG. "
                image={img2}
            >
                <h5>Customer Experience</h5>
                <p>SAP combines all applications for the customer-centered departments within a company. Among these are marketing, sales, service, and e-commerce. These applications are combined in the SAP C/4HANA suite (former SAP Hybris). The products are based on SAP S/4HANA or the SAP Cloud Platform – therefore the name “SAP C/4HANA”. “C” stands for the “Customer” who is in the center of the individual solutions. “4” means the fourth CRM generation.</p>

                <h5>Cloud</h5>
                <p>In S/4HANA Cloud, SAP service will provide and handle almost everything for the customer, including applications, data, runtime, middleware, operating system, servers, storage, and networking.</p>
                <ul>
                    <li>Hybrid Cloud to leverage SAP HANA cloud</li>
                    <li>Protection against cyber threats</li>

                </ul>
            </ZigZag> */}


            <Approach
                title="Approach"
                data-aos="fade-up"
                backgroundImage={bg}
                items={approachItems}
            />


            <Partnerships
                title="Partnerships"
                subtitle="We have a robust ecosystem of ISVs to support our solutions and services"
                partners={[
                    { name: "SAP S/4HANA", logo: logo1 },
                    { name: "Oracle JD Edwards", logo: logo2 },
                    { name: "Microsoft Dynamics 365", logo: logo3 },
                    { name: "Infor", logo: logo4 },
                ]}
            />
            <Footer />

        </>
    );
};

export default SOE;